import * as scoreboard from '../../utils/scoreboard';

angular.module('app.directives.schedule').directive('broadcastSelectSport', () => {
  return {
    restrict: 'E',
    scope: { vm: '=' },
    controller: function ($scope) {
      'ngInject';
      $scope.scoreboard_configuration = $scope.vm.service.broadcast.scoreboard_configuration;
      $scope.sports = scoreboard.getUISports();
      $scope.onChange = function (value) {
        scoreboard.updateSportFromPrefix($scope.scoreboard_configuration, value);
        $scope.vm.service.updateScoreboardMakes();
      };
    },
    template: require('./broadcast-select-sport.html'),
  };
});



// WEBPACK FOOTER //
// ./app/directives/schedule/broadcast-select-sport.js